// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1Cm37","infoBtn":"quickbooks_infoBtn__1AQ5M","formBox":"quickbooks_formBox__2taEN","formFooter":"quickbooks_formFooter__1HAtR"};